import React from "react"

import SEO from "../components/seo"
import { useStaticQuery, graphql } from "gatsby"
import getYouTubeId from "get-youtube-id"
import Helmet from "react-helmet"

import YouTube from "react-youtube"
const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query Index {
      sanityFrontpage {
        frontpageD {
          referenceTitle
          descriptionVideo
          mainImageD {
            asset {
              fluid(maxWidth: 1000) {
                ...GatsbySanityImageFluid
              }
            }
          }
          titleD
          _rawSubtitleD
          fullReferenceD {
            title
            icon {
              asset {
                fluid(maxWidth: 100) {
                  ...GatsbySanityImageFluid
                }
              }
            }
            shortDescription

            reference {
              landingpagesD {
                slugD {
                  current
                }
              }
            }
          }
          FullBannerD {
            slogans {
              sloganPartOne
              sloganPartTwo
            }
            _rawText
          }

          methods {
            title
            image {
              asset {
                fluid {
                  ...GatsbySanityImageFluid
                }
              }
            }
            _rawDescription
            stepArray {
              title
              _rawDescription
            }
          }
          projects {
            logo {
              asset {
                fluid {
                  ...GatsbySanityImageFluid
                }
              }
            }
            name
          }
        }
        additionalFooter {
          titleD
          subtitleD
          releasedD
          buttonD
        }

        seo {
          metaTitleD
          metaDescriptionD
        }
      }
    }
  `)

  function getSEOTitle() {
    const SEO = data.sanityFrontpage.seo

    const RegularTitle = data.sanityFrontpage.frontpageD.titleD

    if (SEO !== null) {
      const SEOtitle = data.sanityFrontpage.seo.metaTitleD
      if (SEOtitle !== null) {
        return SEOtitle
      } else {
        return RegularTitle
      }
    } else {
      return RegularTitle
    }
  }

  function getSEODescription() {
    const SEO = data.sanityFrontpage.seo
    const rawDescription =
      data.sanityFrontpage.frontpageD._rawSubtitleD[0]["children"][0]["text"]
    if (SEO !== null) {
      const SEODescription = data.sanityFrontpage.seo.metaDescriptionD
      if (SEODescription !== null) {
        return SEODescription
      } else {
        return rawDescription
      }
    } else {
      return rawDescription
    }
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    name: "Sweat Agency",
    alternateName: "sweatagency",
    url: "https://sweatagency.com/",
    logo: "",
    sameAs: "https://sweatagency.com/",
  }

  function getIframeContent(url) {
    // const { url } = node
    const id = getYouTubeId(url)

    return <YouTube loading="lazy" videoId={id} />
  }

  return (
    // <Layout
    //   footerTitle={additionalFooterTitle(
    //     data.sanityFrontpage.additionalFooter.titleD
    //   )}
    //   footerButton={additionalFooterButton(
    //     data.sanityFrontpage.additionalFooter.buttonD
    //   )}
    //   footerSubtitle={additionalFooterSubtitle(
    //     data.sanityFrontpage.additionalFooter.subtitleD
    //   )}
    //   footerReleased={additionalFooterReleased(
    //     data.sanityFrontpage.additionalFooter
    //   )}
    // >
    <>
      <SEO
        title={getSEOTitle()}
        description={getSEODescription()}
        schemaMarkup={schema}
      />
      <Helmet>
        <script src="https://webforms.pipedrive.com/f/loader"></script>
      </Helmet>
      <section
        style={{
          backgroundColor: "var(--dark-gray)",
          minHeight: "100vh",
          maxWidth: "100vw",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            right: 100,
            bottom: 0,
            transform: "rotate(45deg)",
            width: "150vw",
            zIndex: "0",
            height: 800,
            backgroundColor: "var(--dark-yellow)",
            opacity: 0.8,
          }}
        ></div>
        <div
          style={{
            textAlign: "center",
            color: "white",
            position: "relative",
            width: "fit-content",
            margin: "auto",
          }}
        >
          <h1 className="removeTitle">
            Vi bygger Danmarks næste Boutique Investment Bank for Tech
            iværksættere. <br />
            Er du Investor, Tech Founder, en anden founder eller bare nysgerrig.
          </h1>
        </div>
        {/* <div
          style={{
            textAlign: "center",
            marginTop: 80,
            padding: 20,
            width: "100%",
            height: "100%",
            overflow: "hidden",
            minWidth: "320px",
            position: "relative",
          }}
          className="pipedriveWebForms"
          data-pd-webforms="https://webforms.pipedrive.com/f/1FPfgKSCbs2EcBegdUqjjAT5Ao3uPRRDS4SeJuGrzsRPesIx49OM6rTJyA8N6YhML"
        > */}
        <iframe
          src={`https://webforms.pipedrive.com/f/1FPfgKSCbs2EcBegdUqjjAT5Ao3uPRRDS4SeJuGrzsRPesIx49OM6rTJyA8N6YhML`}
          scrolling="no"
          seamless="seamless"
          style={{
            border: "none",
            overflow: "scroll",
            width: "100%",
            minWidth: "320px",
            height: "100%",
            position: "relative",
            minHeight: 650,
            opacity: 1,
          }}
        />
        {/* </div> */}
      </section>
    </>

    // </Layout>
  )
}

export default IndexPage

function additionalFooterReleased(data) {
  if (data === null) {
    return false
  } else {
    return true
  }
}

function additionalFooterTitle(data) {
  if (data === null) {
    return "no title"
  } else {
    return data
  }
}

function additionalFooterSubtitle(data) {
  if (data === null) {
    return "no subTitle"
  } else {
    return data
  }
}

function additionalFooterButton(data) {
  if (data === null) {
    return "no button"
  } else {
    return data
  }
}

// function initiateStart() {
//   setTimeout(() => {
//     let loopNumber = 0

//     // document.querySelector(".spanTitle" + loopNumber).style.display = "initial"

//     initiateLoop(loopNumber)
//   }, 3000)
// }
function initiateLoop(loopNumber) {
  if (window.location.href !== "https://sweatagency.com/") {
    return
  } else {
    document.querySelector(".spanTitle" + loopNumber).style.display = "none"

    loopNumber++
    document.querySelector(".spanTitle" + loopNumber).style.display = "initial"

    if (loopNumber === document.querySelectorAll(".allTitles").length - 1) {
      setTimeout(() => {
        reset(loopNumber)
      }, 3000)
    } else {
      setTimeout(() => {
        initiateLoop(loopNumber)
      }, 3000)
    }
  }
}

function reset(loopNumber) {
  document.querySelector(".spanTitle" + loopNumber).style.display = "none"

  loopNumber = 0

  document.querySelector(".spanTitle" + loopNumber).style.display = "initial"

  setTimeout(() => {
    initiateLoop(loopNumber)
  }, 3000)
}

// Stored data

// <div className="index">
//         <section
//           className="introSection"
//           data-sal="fade"
//           data-sal-duration="1300"
//           data-sal-easing="ease-in-out"
//         >
//           {data.sanityFrontpage.frontpageD.descriptionVideo != null ? (
//             <div
//               className="rightWrapper"
//               onClick={e => {
//                 document
//                   .querySelector(".videoContainer")
//                   .classList.add("displayVideoContainer")
//               }}
//             >
//               <Img
//                 fluid={data.sanityFrontpage.frontpageD.mainImageD.asset.fluid}
//                 alt={data.sanityFrontpage.frontpageD.titleD}
//                 // onLoad={initiateStart}
//               />
//             </div>
//           ) : (
//             <div className="rightWrapper">
//               <Img
//                 fluid={data.sanityFrontpage.frontpageD.mainImageD.asset.fluid}
//                 alt={data.sanityFrontpage.frontpageD.titleD}
//                 // onLoad={initiateStart}
//               />
//             </div>
//           )}
//           {data.sanityFrontpage.frontpageD.descriptionVideo != null ? (
//             <>
//               <div
//                 className="videoContainer"
//                 loading="lazy"
//                 onClick={e => {
//                   e.target.classList.remove("displayVideoContainer")
//                 }}
//               >
//                 <FaTimes />
//                 {getIframeContent(
//                   data.sanityFrontpage.frontpageD.descriptionVideo
//                 )}
//               </div>
//             </>
//           ) : (
//             <></>
//           )}

//           <div
//             className="leftWrapper"
//             data-sal="slide-left"
//             data-sal-duration="1300"
//             data-sal-easing="ease-in-out"
//           >
//             <h1
//               data-sal="slide-left"
//               data-sal-duration="1500"
//               data-sal-delay="300"
//               y
//               data-sal-easing="ease-in-out"
//             >
//               {data.sanityFrontpage.frontpageD.titleD}
//               {/* {data.sanityFrontpage.frontpageD.fullReferenceD.map(function (
//                 allTitles,
//                 index
//               ) {
//                 return (
//                   <mark
//                     key={`spanTitle${index}`}
//                     className={`allTitles spanTitle${index}`}
//                   >
//                     {allTitles.title}
//                   </mark>
//                 )
//               })} */}
//             </h1>

//             <CreateBlockcontent
//               content={data.sanityFrontpage.frontpageD._rawSubtitleD}
//             />
//           </div>

//           <ScrollDownArrow className="scrollDownArrow" />
//         </section>
//         <section className="blackBanner">
//           <div className="contentWrapper">
//             <div className="leftWrapper">
//               {data.sanityFrontpage.frontpageD.FullBannerD.slogans.map(
//                 function (allSlogans, index) {
//                   return (
//                     <div
//                       key={`blackBanner${index}`}
//                       className="slogan"
//                       data-sal="slide-right"
//                       data-sal-duration="1300"
//                       data-sal-delay={400 * index}
//                       data-sal-easing="ease-in-out"
//                     >
//                       <p>{allSlogans.sloganPartOne}</p>
//                       <p>{allSlogans.sloganPartTwo}</p>
//                     </div>
//                   )
//                 }
//               )}
//             </div>
//             <div
//               className="rightWrapper"
//               data-sal="fade"
//               data-sal-duration="1500"
//               data-sal-easing="ease-in-out"
//             >
//               <CreateBlockcontent
//                 content={data.sanityFrontpage.frontpageD.FullBannerD._rawText}
//               />
//             </div>
//           </div>
//         </section>

//         <section className="halfCircleMobile">
//           <HalfCircleMobile
//             content={data.sanityFrontpage.frontpageD.fullReferenceD}
//             title={data.sanityFrontpage.frontpageD.referenceTitle}
//             language="danish"
//           />
//         </section>
//         <section
//           className="halfCircleDesktop"
//           data-sal="fade"
//           data-sal-duration="1300"
//           data-sal-easing="ease-in-out"
//         >
//           <HalfCircle
//             content={data.sanityFrontpage.frontpageD.fullReferenceD}
//             title={data.sanityFrontpage.frontpageD.referenceTitle}
//             language="danish"
//           />
//         </section>

//         <section className="methods">
//           <div className="methodWrapper">
//             <div
//               className="titleBox"
//               data-sal="fade"
//               data-sal-duration="1300"
//               data-sal-easing="ease-in-out"
//             >
//               <Img
//                 fluid={
//                   data.sanityFrontpage.frontpageD.methods.image.asset.fluid
//                 }
//                 alt={data.sanityFrontpage.frontpageD.methods.title}
//               />
//               <p className="title">
//
//                 {data.sanityFrontpage.frontpageD.methods.title}
//               </p>

//               <div className="shadowBox"></div>
//             </div>

//             <div
//               className="descriptionBox"
//               data-sal="fade"
//               data-sal-duration="1300"
//               data-sal-easing="ease-in-out"
//             >
//               <CreateBlockcontent
//                 content={
//                   data.sanityFrontpage.frontpageD.methods._rawDescription
//                 }
//               />
//               <div className="shadowBox"></div>
//             </div>

//             {data.sanityFrontpage.frontpageD.methods.stepArray.map(function (
//               stepArray,
//               index
//             ) {
//               return (
//                 <div
//                   key={`description${index}`}
//                   className={`stepArray step${index}`}
//                   data-sal="fade"
//                   data-sal-duration="1300"
//                   data-sal-easing="ease-in-out"
//                 >
//                   <div className="contentBox">
//                     <p className="title">{stepArray.title}</p>
//                     <CreateBlockcontent
//                       className="description"
//                       content={stepArray._rawDescription}
//                     />
//                   </div>

//                   <div className="shadowBox"></div>
//                 </div>
//               )
//             })}
//           </div>
//         </section>

//         <section
//           className="projects"
//           data-sal="fade"
//           data-sal-duration="1300"
//           data-sal-easing="ease-in-out"
//         >
//           {data.sanityFrontpage.frontpageD.projects.map(function (
//             project,
//             index
//           ) {
//             return (
//               <Img
//                 key={`image${index}`}
//                 fluid={project.logo.asset.fluid}
//                 alt={project.name}
//               />
//             )
//           })}
//         </section>
//       </div>
